import { render, staticRenderFns } from "./TerminalCard.vue?vue&type=template&id=38d4148e&scoped=true&"
import script from "./TerminalCard.vue?vue&type=script&lang=js&"
export * from "./TerminalCard.vue?vue&type=script&lang=js&"
import style0 from "./TerminalCard.vue?vue&type=style&index=0&id=38d4148e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4148e",
  null
  
)

export default component.exports